<span class="result">
  {{ 'requirementIntake.details.findings.criterionResult' | translate }}
  <span class="value" [ngClass]="criterionMetCssClass()">
    {{ (criterionMet() ? 'general.yes' : 'general.no') | translate }}
  </span>
</span>
<span class="result">
  {{ 'requirementIntake.details.findings.criterionConfidence' | translate }}
  <span class="value" [ngClass]="confidenceCssClass()">
    {{ confidence() | percent }}
  </span>
</span>
